import styled, { css } from 'styled-components'

export const PillsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
`

export const PillButton = styled.button<{ active: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1rem;
  border: none;
  border-radius: 0.5rem;
  background: ${({ theme }) => theme.grey200Color};
  font-family: Rubik, verdana, sans-serif;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.25rem;
  letter-spacing: 0.0187rem;
  cursor: pointer;
  transition: background 0.15s ease, box-shadow 0.15s ease;

  ${({ active, theme }) =>
    active &&
    css`
      background: ${theme.whiteColor};
      box-shadow: 0 0.25rem 0.625rem 0 rgb(0 0 0 / 8%);
    `}

  &:focus-visible {
    outline: 0.125rem solid ${({ theme }) => theme.primaryColor};
    outline-offset: 0.125rem;
  }
`
